/**
 * Mirrors the page-level customer state into the `_promo_authed` cart
 * attribute, where the Shopify Function can see it. Needed because
 * Shopify doesn't bind the cart to the customer until checkout on
 * stores using New Customer Accounts, leaving the Function's own
 * buyerIdentity.isAuthenticated unreliable on the cart page.
 *
 * Note: /cart/update.js is public, so the attribute is forgeable. Only
 * safe for gates that any signed-up customer can satisfy (i.e.
 * login_state). Do not extend to identity-sensitive gates.
 */
(async function syncPromoAuthedAttribute() {
  if (window.Shopify?.designMode) return;

  const desired = window.__promoCustomerId ? "true" : "";

  let cart;
  try {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) return;
    cart = await res.json();
  } catch {
    return;
  }

  const current = cart.attributes?._promo_authed ?? "";
  if (current === desired) return;

  try {
    await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _promo_authed: desired } }),
    });
  } catch {
    // Best-effort; the next page load retries.
  }
})();
